const bodyElement = document.body;

const modalWindow = document.querySelector('.modal');
const iFrame = document.querySelector('.modal__video') as HTMLIFrameElement;
const sliderItems = document.querySelectorAll(
  '.slider__item--play, .news__advice--play, .article__video'
);

const modalSearchWindow = document.querySelector('.modal.modal--search');
const searchBtnElements = document.querySelectorAll('.header__search-btn');

const closeModal = (modalElement?: Element | null): void => {
  bodyElement.style.paddingRight = '0px';
  modalElement?.classList.add('hidden');
  bodyElement.style.overflowY = 'auto';
};

const openModal = (modalElement?: Element | null): void => {
  bodyElement.style.paddingRight = window.innerWidth - bodyElement.offsetWidth + 'px';
  modalElement?.classList.remove('hidden');
  bodyElement.style.overflowY = 'hidden';
};

modalWindow?.addEventListener('click', (e) => {
  if (e.target === iFrame) {
    return;
  }
  closeModal();
});

modalSearchWindow?.addEventListener('click', (e) => {
  if ((e.target as Element)?.classList.contains('modal__content')) {
    closeModal(modalSearchWindow);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeModal(modalWindow);
    closeModal(modalSearchWindow);
  }
});

sliderItems.forEach((item) => {
  item.addEventListener('click', (e) => {
    const clickedSlide = e.target as HTMLElement;
    if (clickedSlide.tagName === 'A') {
      return;
    }
    const parentSlide = clickedSlide.closest('[data-link]') as HTMLElement;
    const dataLink = parentSlide.dataset.link;
    if (dataLink) {
      iFrame.src = dataLink;
      openModal(modalWindow);
    }
  });
});

searchBtnElements.forEach(searchBtn => {
  searchBtn.addEventListener('click', () => {
    openModal(modalSearchWindow);
  });
});
